import Vue from 'vue';
import Vuex from 'vuex';
import authentication from './modules/authentication';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userPermissions: {
      user: '["ROLE_USER"]',
      admin: '["ROLE_ADMIN"]',
      superuser: '["ROLE_SUPER_ADMIN"]',
      integration: '["ROLE_INTEGRATION"]',
      serviceintegration: '["ROLE_SERVICE_INTEGRATION"]',
    },
    showCdLinks: false,
    backRoute: '/customers',
    loadingCounter: 0,
    popupAlertStatus: false,
    popupAlertMessage: '',
    popupAlertTitle: '',
    popupAlertType: 'error',
    availableAppCodes: ['KA', 'KOA', 'DDN', 'FOR1'], // This array must be updated when KAAPI appCodeEnum will be changed
    customPageTitle: null,
    licensesUpdatedTimestamp: null,
  },
  mutations: {
    increaseLoadingCounter(state) {
      state.loadingCounter += 1;
    },
    decreaseLoadingCounter(state) {
      state.loadingCounter -= 1;
    },
    setPopupAlert(state, payload) {
      state.popupAlertTitle = payload.title;
      state.popupAlertMessage = payload.message;
      state.popupAlertType = payload.color;
      state.popupAlertStatus = true;
    },
    showAlertPopup(state) {
      state.popupAlertStatus = true;
    },
    closeAlertPopup(state) {
      state.popupAlertStatus = false;
      state.popupAlertMessage = '';
      state.popupAlertType = 'error';
      state.popupAlertTitle = '';
    },
    setCustomPageTitle(state, title) {
      state.customPageTitle = title;
    },
    clearCustomPageTitle(state) {
      state.customPageTitle = null;
    },
    setBackRoute(state, route) {
      state.backRoute = route;
    },
    resetBackRoute(state) {
      state.backRoute = '/customers';
    },
    triggerLicensesUpdate(state) {
      state.licensesUpdatedTimestamp = Date.now();
    },
  },
  modules: {
    auth: authentication,
  },
});
